module.exports = __webpack_public_path__ + "static/media/49.e88e29eb.svg";